/**
 * `utils/animation.js`
 * - `slideUp`, `slideDown`, `slideToggle` のユーティリティ
 *
 * 使用方法:
 * - import {slideUp, slideDown, slideToggle} from "../utils/animation.js";
 */


/**
 * スライドアップ
 * @param {HTMLElement} el - 対象要素
 * @param {number} duration - アニメーション時間（ms）
 */
export const slideUp = (el, duration = 300) => {
  el.style.height = el.offsetHeight + "px";
  void el.offsetHeight;
  el.style.transition = `height ${duration}ms ease, margin ${duration}ms ease, padding ${duration}ms ease, opacity ${duration}ms ease`;
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.style.opacity = 0;

  setTimeout(() => {
    el.style.display = "none";
    ["height", "paddingTop", "paddingBottom", "marginTop", "marginBottom", "overflow", "transition", "opacity"]
      .forEach(prop => el.style.removeProperty(prop));
  }, duration);
};

/**
 * スライドダウン
 * @param {HTMLElement} el - 対象要素
 * @param {number} duration - アニメーション時間（ms）
 */
export const slideDown = (el, duration = 300) => {
  el.style.removeProperty("display");
  let display = window.getComputedStyle(el).display;
  if (display === "none") {
    display = "block";
  }
  el.style.display = display;

  const { paddingTop, paddingBottom, marginTop, marginBottom } = window.getComputedStyle(el);
  const height = el.clientHeight - parseInt(paddingTop) - parseInt(paddingBottom);

  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.style.opacity = 0;
  void el.clientHeight;
  el.style.transition = `height ${duration}ms ease, margin ${duration}ms ease, padding ${duration}ms ease, opacity ${duration}ms ease`;
  el.style.height = height + "px";
  el.style.paddingTop = paddingTop;
  el.style.paddingBottom = paddingBottom;
  el.style.marginTop = marginTop;
  el.style.marginBottom = marginBottom;
  el.style.opacity = 1;

  setTimeout(() => {
    ["height", "overflow", "transition", "opacity"].forEach(prop => el.style.removeProperty(prop));
  }, duration);
};

/**
 * スライドのトグル
 * @param {HTMLElement} el - 対象要素
 * @param {number} duration - アニメーション時間（ms）
 */
export const slideToggle = (el, duration = 300) => {
  if (window.getComputedStyle(el).display === "none") {
    slideDown(el, duration);
  } else {
    slideUp(el, duration);
  }
};
